import { useAuth } from '@/contexts/AuthContext';

export const useIsSuperAdmin = () => {
  const { user } = useAuth();
  // TODO: Replace with proper RBAC when backend supports it
  const SUPER_ADMIN_EMAILS = ['jonp4208@gmail.com'];
  return user && SUPER_ADMIN_EMAILS.includes(user.email);
};
